








































import * as fb from '@/firebase';
import * as _ from 'lodash';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { InviteCode } from '@/models/invite-code';
import { InviteCodeModelUtil } from '../../model-utils/invite-code-model-util';
import { UserProfileUtil } from '../../model-utils/user-profile-util';

@Component({})
export default class InviteCodesView extends Vue {
  inviteCodes: InviteCode[] = [];
  userMap: any = {};

  async created() {
    this.inviteCodes = await InviteCodeModelUtil.getAllCodes();
    const userIds = _.uniq(
      this.inviteCodes
        .map(i => i.creator)
        .concat(this.inviteCodes.map(i => i.lastUpdatedBy))
    );
    const users = await UserProfileUtil.hydrateUsers(userIds);
    users.map(u => (this.userMap[u.id] = u));
    this.$forceUpdate();
  }

  userLink(id: string) {
    const user = this.userMap[id];
    if (!user) {
      return '/notFound';
    }
    return user.link;
  }
  
  username(id: string) {
    const user = this.userMap[id];
    if (!user) {
      return '????';
    }
    return user.username;
  }
}
